module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Light-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Light-webfont.woff
// module id = 346
// module chunks = 0